import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { PLAN_USAGE } from '../planUsageDesignTokens'
import {
  planUsageHeatmapLegendCaptionSx,
  planUsageHeatmapLegendEmptySwatchSx,
  planUsageHeatmapLegendLabelSx,
  planUsageHeatmapLegendLevelSwatchSx,
  planUsageHeatmapLegendRootSx,
} from './planUsageActivityHeatmapLegendSx.js'

export function PlanUsageActivityHeatmapLegend() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={planUsageHeatmapLegendRootSx}
    >
      <Typography sx={planUsageHeatmapLegendCaptionSx}>2023 Sunday first</Typography>
      <Stack direction="row" alignItems="center" spacing={1.25} aria-label="Heatmap legend">
        <Typography sx={planUsageHeatmapLegendLabelSx}>Less</Typography>
        <Box sx={planUsageHeatmapLegendEmptySwatchSx} />
        <Box sx={planUsageHeatmapLegendLevelSwatchSx(PLAN_USAGE.heatLow)} />
        <Box sx={planUsageHeatmapLegendLevelSwatchSx(PLAN_USAGE.heatMid)} />
        <Box sx={planUsageHeatmapLegendLevelSwatchSx(PLAN_USAGE.heatHigh)} />
        <Typography sx={planUsageHeatmapLegendLabelSx}>More</Typography>
      </Stack>
    </Stack>
  )
}
